import axios from "axios";
import Swal from 'sweetalert2';

const state = {
  reviewsList: [], 
  reviewArr: [],
  reviewArray: [],
  reviewID: '',
  selectedReview: null,
  selectedEmployee: null,
  isEditing: false
};
  
const mutations = {
  initializeStore(state){
    state.reviewsList = [];
    state.reviewArr = [];
    state.reviewArray = [];
    state.reviewID = "";
    state.selectedReview = null;
    state.selectedEmployee = null;
    state.isEditing = false;
  },
  SET_SELECTED_REVIEW(state, Review) {
    state.selectedReview = Review;
    state.isEditing = true;
  },
  LIST_REVIEWS(state, Reviews) {
    state.reviewsList = Reviews;
  },
  REVIEWS_ARRAY(state, Reviews){
    state.reviewArray = Reviews;
  },
  SET_SELECTED_EMPLOYEE(state, employee) {
    state.selectedEmployee = employee;
  },
  SET_STATE(state, payload) {
    for (const key in payload) {
        if (payload.hasOwnProperty(key) && key in state) {
            state[key] = payload[key];
        }
    }
  },
  SET_SEARCH_FILTERS(state, search_filter){
    for(const [key, value] of Object.entries(search_filter)){

    }
  },
  RESET_SEARCH_FILTERS(state){

  }
};
  
const actions = {
  updateState({ commit }, newState) {
    commit('SET_STATE', newState);
  },
  
  async createSalaryReview({ commit,state }, formData) {
    return axios.post('api/v1/create-salary-review/', formData)
    .then((response)=>{
      return response;
    })
    .catch((error)=>{
      console.log(error.message);
      throw error;
    })
  },

  fetchSalaryReviews({ commit,state }, formData) {
    state.reviewArr = [];
    axios.post(`api/v1/get-salary-reviews/`,formData)
    .then((response)=>{
      for(let i=0; i< response.data.length; i++){
        state.reviewArr.push((response.data[i].employee.employee_name + " - " + response.data[i].date));
      }
      commit('LIST_REVIEWS', response.data);
    })
    .catch((error)=>{
      console.log(error.message);
    })
    
  },
  fetchSalaryReview({ commit,state }, formData) {
    axios.post(`api/v1/get-salary-reviews/`,formData)
    .then((response)=>{
      state.selectedReview = response.data;
      const selectedEmployee = response.data.employee.staff_number + " - " + response.data.employee.employee_name;
      commit('SET_SELECTED_REVIEW',response.data);
      commit('SET_SELECTED_EMPLOYEE', selectedEmployee);

    })
    .catch((error)=>{
      console.log(error.message);
    })
    
  },
  handleSelectedSalaryReview({ commit, state }, option){
    const selectedReview = state.reviewsList.find(review => (review.employee.employee_name + " - " + review.date) === option);
    if (selectedReview) {
        state.reviewID = selectedReview.salary_review_id;
        state.reviewArray = [...state.reviewArray, selectedReview];
    }
    commit('REVIEWS_ARRAY', state.reviewArray);
      
  },

  async updateSalaryReview({ commit,state }, formData) {
    return axios.put(`api/v1/update-salary-review/`,formData)
    .then((response)=>{
      return response;
    })
    .catch((error)=>{
      console.log(error.message);
      throw error;
    })  
  },

  deleteSalaryReview({ commit,state }, formData) {
    Swal.fire({
      title: "Are you sure?",
      text: `Do you wish to delete Salary Review?`,
      type: 'warning',
      showCloseButton: true,
      showCancelButton: true,
      confirmButtonText: 'Yes Delete Salary Review!',
      cancelButtonText: 'Cancel!',
      customClass: {
          confirmButton: 'swal2-confirm-custom',
          cancelButton: 'swal2-cancel-custom',
      },
      showLoaderOnConfirm: true,
    }).then((result) => {
      if (result.value) {
        axios.post(`api/v1/delete-salary-review/`,formData)
        .then((response)=>{
          if(response.data.msg == "Success"){
              Swal.fire("Poof! Salary Review removed succesfully!", {
                icon: "success",
              }); 
          }else{
            Swal.fire({
              title: "Error Deleting Salary Review",
              icon: "warning",
            });
          }                   
        })
        .catch((error)=>{
          console.log(error.message);
          Swal.fire({
            title: error.message,
            icon: "warning",
          });
        })
      }else{
        Swal.fire(`Salary Review has not been deleted!`);
      }
    })
  },

};
  
const getters = {
  // users: (state) => state.users,
  // currentUser: (state) => state.currentUser,
};
  
export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
  
  